/**
 * Payment Methods Slider
 * 
 * Initializes Swiper slider for mobile payment method selection
 * 
 * @package betbeast
 */

import Swiper from 'swiper';

export class PaymentMethodsSlider {
    constructor(modalElement) {
        this.modal = modalElement;
        this.swiper = null;
        
        if (!this.modal) {
            console.warn('Modal element not provided to PaymentMethodsSlider');
            return;
        }
        
        this.init();
    }
    
    /**
     * Initialize Swiper slider for mobile payment methods
     */
    init() {
        const sliderContainer = this.modal.querySelector('.wallet-deposit-payment-methods-slider');

        if (!sliderContainer) {
            return;
        }

        // Initialize Swiper.
        // slidesPerView: 'auto' lets the CSS slide width drive the logo size, so
        // spaceBetween controls the gap — sized to show 2 full logos + a peek of
        // the third. observer/observeParents make Swiper re-measure when the modal
        // (an ancestor) is revealed, since it's initialized while the modal is closed.
        this.swiper = new Swiper(sliderContainer, {
            slidesPerView: 'auto',
            spaceBetween: 6,
            freeMode: true,
            grabCursor: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                // Hide on desktop (>768px)
                769: {
                    enabled: false
                }
            }
        });
    }
    
    /**
     * Destroy swiper instance
     */
    destroy() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
    
    /**
     * Update swiper (useful after DOM changes)
     */
    update() {
        if (this.swiper) {
            this.swiper.update();
        }
    }
}
